export default () => {
  const button = document.getElementsByClassName('navbar-toggler')[0]
  const target = document.getElementsByClassName('offcanvas-collapse')[0]

  button.addEventListener('click', function () {
    target.classList.toggle('open');
  }, true);
}
